import { render, staticRenderFns } from "./m-product-configurator.vue?vue&type=template&id=b15f77e6&scoped=true&"
import script from "./m-product-configurator.vue?vue&type=script&lang=js&"
export * from "./m-product-configurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15f77e6",
  null
  
)

export default component.exports